var _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccidentalDamage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 39,
    viewBox: "0 0 24 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-describedby": "accidental-damage-title accidental-damage-desc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "accidental-damage-title"
  }, "Accidental Damage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "accidental-damage-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "accidental-damage-desc"
  }, "A cracked and broken phone")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3131 14.4805V36.6036C19.3131 37.3755 18.6882 38.0003 17.917 38.0003H2.40972C1.63856 38.0003 1.01367 37.3755 1.01367 36.6036V5.58907C1.01367 4.81791 1.63856 4.19238 2.40972 4.19238H12.2815",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.18945 8.49949H10.1868",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.18945 31.6841H19.1385",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8046 34.8159H9.52148",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 29.9841L8.24841 22.7363V27.872L16.0967 20.0244",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55125 26.2409V19.5205",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6719 22.7842L15.544 24.6563",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9601 1.68519C18.1706 2.18176 18.4496 2.64241 18.7364 3.09664C19.2721 3.94543 19.822 4.78524 20.3596 5.63211C20.7394 6.23005 21.1064 6.83632 21.4079 7.47917C21.6915 8.08545 21.9263 8.71034 22.0142 9.37693C22.2471 11.1483 21.669 12.579 20.1902 13.6119C19.3696 14.1848 18.4432 14.392 17.4526 14.3426C16.8252 14.3112 16.2202 14.179 15.6665 13.8756C14.4219 13.1942 13.6417 12.169 13.4114 10.7524C13.2722 9.89852 13.4133 9.07603 13.7065 8.27215C13.9754 7.53563 14.343 6.8498 14.7638 6.19091C15.3406 5.28887 15.918 4.38747 16.4897 3.48286C16.881 2.86375 17.2409 2.22732 17.5168 1.54726C17.5893 1.36826 17.647 1.18285 17.7118 1C17.7118 1 17.8594 1.44717 17.9601 1.68519Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccidentalDamage);
export default __webpack_public_path__ + "static/media/accidental-damage.20f7830a2e173393a0c1679a566e684a.svg";
export { ForwardRef as ReactComponent };